var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.227 3.227c.275-.275.71-.303 1.016-.07l.08.07L8 6.905l3.678-3.678c.282-.282.728-.301 1.032-.057l.063.057c.275.275.303.71.062 1.026l-.062.07L9.095 8l3.678 3.678c.283.282.301.728.057 1.032l-.057.063c-.275.275-.71.303-1.025.062l-.07-.062-3.679-3.678-3.677 3.678c-.282.283-.728.301-1.032.057l-.063-.057c-.275-.275-.303-.71-.062-1.025l.062-.07L6.904 8 3.227 4.322c-.282-.282-.301-.728-.057-1.032l.057-.063z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.086 3.086c.345-.346.892-.381 1.278-.087l.011.008.09.078L8 6.622l3.536-3.536c.356-.356.917-.38 1.3-.071l.008.006.07.064c.348.347.38.895.08 1.289l-.005.005-.074.085L9.378 8l3.537 3.536c.355.356.379.917.07 1.3l-.006.008-.064.07c-.347.348-.895.38-1.289.08l-.005-.004-.085-.075-3.537-3.537-3.535 3.537c-.355.355-.917.379-1.3.07l-.008-.006-.07-.064c-.348-.347-.38-.895-.08-1.289l.005-.005.074-.085L6.622 8 3.086 4.464c-.356-.355-.38-.917-.071-1.3l.006-.008.065-.07zM6.904 8l-3.677 3.678-.062.07c-.24.316-.213.75.062 1.025l.063.057c.304.244.75.226 1.032-.057L8 9.095l3.679 3.678.07.062c.316.24.75.213 1.025-.062l.057-.063c.244-.304.226-.75-.057-1.032L9.095 8l3.678-3.678.062-.07c.24-.315.213-.75-.062-1.025l-.063-.057c-.304-.244-.75-.225-1.032.057L8 6.905 4.322 3.227l-.079-.07c-.306-.233-.741-.205-1.016.07l-.057.063c-.244.304-.225.75.057 1.032L6.904 8z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.437288868156eea99fa555a419eb255a.svg";
export { ForwardRef as ReactComponent };